import { MetadataArrayItem } from "./attributeMetadata";

export interface TitleItem {
  title: string;
  evidences: TitleEvidence[];
}

export interface TitleEvidence {
  evidence_type?: string;
  evidence_subtype?: string[] | null;
  metadata: MetadataArrayItem[];
}

export enum TitleEvidenceType {
  INTERNAL_EVIDENCE = "internal_evidence",
  EXTERNAL_EVIDENCE = "external_evidence",
  MODERN_SCHOLARSHIP = "modern_scholarship",
}

export const TITLE_EVIDENCE_TYPE_LABELS: Record<TitleEvidenceType, string> = {
  [TitleEvidenceType.INTERNAL_EVIDENCE]: "Internal Evidence",
  [TitleEvidenceType.EXTERNAL_EVIDENCE]: "External Evidence",
  [TitleEvidenceType.MODERN_SCHOLARSHIP]: "Modern Scholarship",
};
